module.exports = __webpack_public_path__ + "img/mall3.42c9b5fd.png";